import { useDeleteClassesMutation } from '../types/planung-graphql-client-defs';
import { useMemorizedCacheTags } from './useMemorizedCacheTag';

export const useDeleteClasses = () => {
  // Die Zuordnungen verlieren die Klasse: ihre Listen müssen mit neu laden.
  const updateContext = useMemorizedCacheTags(['CLASSES', 'TEACHINGBLOCK_VERSIONS', 'LESSONS', 'LESSON_CLASS']);

  const [, deleteClasses] = useDeleteClassesMutation();

  // Das Backend löst die Klasse aus allen Zuordnungen und aus Epochenplan-Versionen und löscht sie
  // dann; steckt sie in einer Stundenplan-Version, lehnt es ab, bevor irgendetwas geändert ist.
  const deleteClass = async (uuid: string) => {
    return await deleteClasses({ uuid }, updateContext);
  };

  return { deleteClass };
};
